import { DisclosureType } from '@/types';
import { GHGProtocolIcon } from '@/components/ghg-protocol-icon';

// The registry of creatable disclosure types — the single source the "New
// disclosure" picker renders (mirrors suit's `data/disclosures`). A new
// disclosure type is added HERE (one entry) plus to the `DisclosureType` union;
// it then appears in the searchable picker automatically. This is what makes
// the create flow scale to many types without a button-per-type.
type NewDisclosureType = {
  type: DisclosureType;
  name: string;
  icon: any;
};

const disclosureTypes: NewDisclosureType[] = [
  {
    type: 'community',
    name: 'Community emissions disclosure',
    icon: <GHGProtocolIcon magnitude='small' />,
  },
  {
    type: 'gpc',
    name: 'GPC report',
    icon: <GHGProtocolIcon magnitude='small' />,
  },
];

export { disclosureTypes };
export type { NewDisclosureType };
